import './index.less';
import * as React from 'react';
import cx from 'classnames';
import MoCommonTop from '@src/ui-components/mo-common-top';

const styles = require('./index.less');

const MoActivityRules = ({ className, title = '活动规则', contentHtml = '', status = 'idle', onRetry, children }) => {
  const isReady = status === 'ready';
  const isError = status === 'error';

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.layer1} data-name="bg" />

      <div className={styles.bottomSlot} data-name="通用-下方按钮组">
        {children}
      </div>

      <section className={styles.group1} data-name="活动规则主体">
        <div className={styles.contentContainer} data-name="活动规则-仅占位及样式参考">
          {isReady ? <div className={styles.content} data-role="rules-content" dangerouslySetInnerHTML={{ __html: contentHtml }} /> : null}
          {isError ? (
            <div className={styles.failure} data-role="rules-failure">
              <p>内容加载失败，请稍后重试</p>
              <button type="button" className={styles.retryButton} onClick={onRetry}>
                重新加载
              </button>
            </div>
          ) : null}
        </div>

        <h1 className={styles.title} data-name="活动规则-标题">
          {title}
        </h1>
      </section>

      <MoCommonTop />
    </div>
  );
};

export default React.memo(MoActivityRules);
